<div :class="inputClass" ref="dropdownContainer">

    <div
      :data-qa-id="`${name}-selectedValues`"
      :class="['selected-values', disabled ? 'disabled-input' : '', isDropdownOpen ? 'dropdown-open' : '']"
      v-tooltip="{
        content: $t('pages.inventory_ingestion_hub.family_bulk_edit.common.disabled_tooltip'),
        placement: 'top-start',
        triggers: ['click','hover'],
        html: true,
        disabled: !disabled
      }"
      @click="toggleDropdown"
    >
      <div class="labelCircle" :data-qa-id="`${name}-labelCircle`">
        <MdTypography
          tag="span"
          variant="body2--medium"
          :color="'spirits--900'"
          :data-qa-id="`${name}-labelText`"
        >
          {{ label }}
        </MdTypography>
        <MdTypography
          v-if="selectedItems.length > 0 && selectedItems.length <= 9 && isMultiSelect"
          tag="span"
          :variant="'heading6--regular'"
          color="blue-duck--500"
          v-html="NUMBER_CIRCLE_GLYPH[selectedItems.length]"
        ></MdTypography>
        <span
          v-if="selectedItems.length > 9 && isMultiSelect"
          class="circle"
          :data-qa-id="`${name}-circle`"
        >
          {{ selectedItems.length }}
        </span>
      </div>
      <span class="dropdownArrow" :data-qa-id="`${name}-drodownArrow`">
        <MdIconArrowCaret
          :rotate="isDropdownOpen ? 'up' : 'down'"
          :color="isDropdownOpen ? 'spirits--900' : 'spirits--600'"
          :data-qa-id="`${name}-caret`"
        ></MdIconArrowCaret>
      </span>
    </div>
  
    <div v-if="isDropdownOpen" class="dropdown" :data-qa-id="`${name}-dropdown`">
      <div
        class="dropdownListHeadWrapper"
        :data-qa-id="`${name}-dropdownListHeadWrapper`"
      >
        <div v-if="enableSearch">
          <TextField 
            :id="`dropdown_search_${name}`"
            :input-class="['dropdown_search']"
            v-model="searchFieldValue"
            data-qa-id="dropdown_search" 
            name="dropdown_search"
            :modelValue="searchFieldValue"
            :searchEnable="true" 
            :placeholder="$t('pages.inventory_ingestion_hub.family_search_placeholder')" 
            :handleEnterKeyUp="handleSearch"
            :keyUp="showEmptySearchResults"  
            :showCrossIcon="true"
            :onSearchCrossIconClick="clearSearch" 
          />
        </div>

        <div class="toggle-button-container" :data-qa-id="`${name}-toggleButtonContainer`" v-if="showToggleButton" @click.stop>
          <MdTypography variant="body2--regular" color="spirits--900">
            {{toggleButtonText}}
          </MdTypography>

          <ToggleSwitch :model-value="toggleButton" size="small" :switch-on-color="'var(--md-color--blue-duck--500)'"
            :switch-off-color="'var(--md-color--spirits--300)'" input-id="multi-select-toggle-switch"
            @change="handleToggleButtonChange" />
        </div>

        <div v-if="filteredResults?.length">
          <div
            class="dropdownInsideNameDiv"
            :data-qa-id="`${name}-dropdownInsideNameDiv`"
          >
            <div class="dropdownListHeadWrapper__radio-selectall" v-if="isMultiSelect">
              <input
                type="checkbox"
                :checked="isAllOptionsSelected"
                @change="toggleSelectAllOption($event)"
                value="Select all"
                id="Select all"
              />
              <label for="Select all">
                <MdTypography variant="body2--medium" color="spirits--900">
                    {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.select_all', { count: filteredResults?.length }) }}
                </MdTypography>
              </label>
            </div>
            <div v-else>
              <MdTypography variant="body1--medium" color="spirits--900">
                {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.existing_families') }}
              </MdTypography>
            </div>
    
            <span
              :class="[selectedItems.length == 0 ? 'disabledReset' : 'enabledReset', 'iconWrap']"
              :data-qa-id="`${name}-iconWrap`"
              @click="resetDropdown"
            >
              <MdIconReload
                v-bind="{size:'sm',color:'spirits--600'}"
                slot="icon-start"
                :data-qa-id="`${name}-icon`"
              ></MdIconReload>
              <MdTypography variant="micro1--medium" color="spirits--700" :data-qa-id="`${name}-reset`" >
                {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.reset') }}
              </MdTypography>
            </span>
          </div>
    
          <div
            class="dropdownOptions"
            :class="['heightChange']"
            :data-qa-id="`${name}-dropdownOptions`"
          >
            <div
              class="option"
              v-for="option in filteredResults"
              :key="'dropdownOption-key-' + (option?.displayFamilyName || option?.name || '-')"
              :class="[isSelectedOption(option) ? 'selected' : '']"
              :data-qa-id="`${name}-option`"
              @click="selectRadioOption(option)" 
            >
              <input
                v-if="isMultiSelect"
                :id="'input-id-' + (option?.displayFamilyName || option?.name || '-')" 
                :data-qa-id="`${name}-dropdownOptionsInput`"
                type="checkbox"
                :checked="selectedOption(option)"
                :value="option?.displayFamilyName || option?.name || '-'"
                @change="toggleOption(option, $event)"
              />
              <input v-if="showRadio" type="radio" :name="name" :value="option?.displayFamilyName || option?.name || '-'" :checked="selectedOption(option)"/>
              <label
                :for="'input-id-' + (option?.displayFamilyName || option?.name || '-')"
                :data-qa-id="`${name}-dropdownOptionsLabel`"
              >
                <MdTypography :variant="'body2--medium'" :color="'spirits--900'">
                  {{ option?.displayFamilyName || option?.name || '-' }}
                </MdTypography>
              </label>
            </div>
          </div>
        </div>
        <div class="no_results_found" v-else>
          <div class="no-results-illustration">
            <img :src="no_result_image" alt="No results illustration" />
          </div>
          <div class="no-results-text">
            <MdTypography variant="body1--medium" color="spirits--800" textAlign="center">
              {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.no_matching_family_found') }}
            </MdTypography>
            <MdTypography variant="body1--regular" color="spirits--700" textAlign="center">
              {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.no_matching_family_found_desc') }}
            </MdTypography>
          </div>
        </div>
      </div>
      <div class="dropdownActions" v-if="showApply || showCancel" :data-qa-id="`${name} dropdownActions`">
        <div class="dropdownApply" v-if="showCancel" :data-qa-id="`${name} cancel`">
          <MdButton color="lightgrey" :data-qa-id="`${name} cancelbtn`" @click="cancelMapFamily" :disabled="!actionBtnActive">
            {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.cancel') }}
          </MdButton>
        </div>
        <div class="dropdownApply" v-if="showApply" :data-qa-id="`${name} apply`">
          <MdButton color="blue" @click="applyMapFamily" :disabled="!actionBtnActive"
            :data-qa-id="`${name} applybtn`">
            {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.map_family') }}
          </MdButton>
      </div>
    </div>
    </div>
</div>
  